import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { FileUsage } from "./file-usage";
import { ObjectType } from "./object-type";
import { FileLinkedType } from "./file-linked-type";
import { DbBaseFormatSpecificationInfos } from "./db-base-format-specification-infos";
import { ObjectLayer } from "./object-layer";
import { ObjectClass } from "./object-class";
import { DbFileExtensionInfos } from "./db-file-extension-infos";

export class DbFormatInfos extends DbMongoBaseInfos {
  isSystem: boolean = false;
  isDownloadable: boolean = false;
  isUploadable: boolean = false;
  isDeletable: boolean = false;
  isRestricted: boolean = false;
  isUserDataMandatory: boolean = false;
  enableParsing: boolean = false;
  usage: FileUsage | null = null;
  objectType: ObjectType | null = null;
  name: string | null = null;
  description: string | null = null;
  maxFileSizeMB: number | null = 0;
  platformId: number | null = 0;
  defaultStorageId: number | null = null;
  linkedType: FileLinkedType | null = null;
  specifications: DbBaseFormatSpecificationInfos | null = null;
  objectTypes: ObjectType[] | null = null;
  objectLayers: ObjectLayer[] | null = null;
  objectClasses: ObjectClass[] | null = null;
  fileExtensions: DbFileExtensionInfos[] | null = null;

  constructor(init?: Partial<DbFormatInfos>) {
    super();
    Object.assign(this, init);
  }
}

export interface UploadCardFormatDto {
  id: number;
  name: string; // TODO : if not used, remove
  objectType: ObjectType | null;
  description?: string; // TODO : if not used, remove
  maxFileSizeMb: number;
  acceptsFiles: { [key: string]: string[] };
  isUploaded: boolean;
  userHasRighToDelete: boolean;
  isUserDataMandatory: boolean;
  linkedType?: FileLinkedType | null;
}
